<template>
  <div class="purchases">
    <div class="purchases__inner">
      <el-collapse
          v-if="orders.length"
          v-model="collapse"
          class="purchases__list"
      >
        <order-card
            v-for="order in orders"
            :key="order.node.uuid"
            :order="order.node"
        />
      </el-collapse>
      <div class="purchases__list" v-if="isLoading">
        <order-card-skeleton
            v-for="idx in 5"
            :key="idx"
        />
      </div>
    </div>
    <div class="purchases__empty" v-if="!orders.length && !isLoading">
      <p>{{ t('profile.purchases.empty') }}</p>
    </div>
  </div>
</template>

<script setup>
import OrderCard from "@/components/cards/order-card.vue";
import {computed, onMounted, ref} from "vue";
import {Orders} from "@/core/api/orders.js";
import {useAuthStore} from "@/stores/auth.js";
import OrderCardSkeleton from "@/components/skeletons/order-card-skeleton.vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n()
const authStore = useAuthStore()

const accessToken = computed(() => authStore.accessToken);
const userEmail = computed(() => authStore.user?.email);

const collapse = ref([]);
const orders = ref([])
const isLoading = ref(true);

const fetchOrders = async () => {
  isLoading.value = true

  setTimeout(async () => {
    const res = await Orders.getOrders("", accessToken.value, userEmail.value);
    orders.value = res.data.orders.edges
        .filter((order) => order.node.status !== 'PENDING')
        // .filter((order) => order.node.status !== 'MOMENTAL')
        // .filter((order) => order.node.status !== 'DELIVERING')
        // .filter(order =>
        //     order.node.status !== 'PAYMENT'
        //     ||
        //     (order.node.paymentsTransactions?.length > 0)
        // )

    isLoading.value = false;
  }, 500);
}

onMounted(async () => {
  await fetchOrders()
})
</script>

<style lang="scss" scoped>
.purchases {
  background-color: #FBFBFB;

  &__inner {
    padding: 10px;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  
  &__empty {
    padding-block: 25px;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    color: #222;
  }
}


:deep(.el-collapse) {
  border: none !important;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-block: 20px
}
:deep(.el-collapse-item) {
  border-radius: 16px;
  border: 1px solid #01AC1B;
  background-color: #FBFBFB;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.3);
}
:deep(.el-collapse-item__header) {
  background-color: transparent !important;
  border-bottom: none !important;
  line-height: 100% !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  padding-inline: 8px !important;
  color: #01AC1B !important;
}
:deep(.el-collapse-item__header.focusing:focus:not(:hover)) {
  color: #01AC1B !important;
}
:deep(.el-collapse-item__wrap) {
  border-top: 2px solid #01AC1B;
  border-bottom: none !important;
  background-color: transparent !important;
}
:deep(.el-collapse-item__content) {
  padding: 10px !important;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
:deep(.el-collapse .el-icon) {
  display: none !important;
}
</style>